import styled from "styled-components";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import Form from "./Form";
import AdminForm from "./AdminForm";
import Preview from "../../../assets/ad.png";
import pages from "../../../constants/pages";
import Sprintex from "../../../assets/Sprintex.png";
import { colors } from "../../css components/Style";
import { PrimaryButton } from "../../css components/Button";
import {
  setActiveBrand,
  signInMember,
  signOutMember,
} from "../../../redux/slices/memberSlice";
import dashboardLayoutRoutes from "../../../router/router components/dashboardLayoutRoutes";

const ImageDiv = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 240px;
  padding: 80px 20px;
`;

const QuoteBox = styled.div`
  margin: auto 20px;
  color: white;
`;

const AdImage = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  text-align: end;
  justify-content: end;
  width: 100%;
`;

export default function SelectRole({
  brands,
  businessEntityID,
  userID,
  component = "",
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authToken =
    useSelector((state) => state?.memberDetails.authToken) ||
    sessionStorage.getItem("authToken");

  const agencyID =
    useSelector((state) => state?.memberDetails.agencyID) ||
    sessionStorage.getItem("agencyID");

  const { brandType, activeBrand } = useSelector(
    (state) => state.memberDetails
  );

  const [currentBrand, setCurrentBrand] = useState({
    ID: activeBrand.ID,
    name: activeBrand.name,
    type: activeBrand.brandType || brandType,
  });

  return (
    <Box display="flex" height="100vh" width="100%">
      <Box
        flex="0 0 30%"
        bgcolor={colors.sprintexBlue}
        style={{ position: "relative" }}
      >
        <ImageDiv>
          <Image src={Sprintex} />
        </ImageDiv>

        <QuoteBox>
          <Typography style={{ fontSize: "25px" }}>
            Create. Target. Launch.
          </Typography>
          <Typography style={{ fontSize: "25px" }}>
            {" "}
            Your multi-channel campaigns
          </Typography>
          <Typography style={{ fontSize: "25px" }}>start here.</Typography>

          <Typography
            style={{ fontSize: "14px", marginTop: "25px", opacity: "0.8" }}
          >
            From audience to action—powerful campaigns made simple.
          </Typography>
        </QuoteBox>

        <AdImage>
          <img src={Preview} style={{ height: "250px" }} alt="!" />
        </AdImage>
      </Box>

      <Box bgcolor="white" sx={{ padding: "20px", width: "70%" }}>
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "flex-end",
          }}
        >
          {agencyID && (
            <PrimaryButton
              style={{ float: "left" }}
              variant="outlined"
              onClick={() => addNewBrand()}
            >
              Add New Brand
            </PrimaryButton>
          )}

          {agencyID && (
            <PrimaryButton
              style={{ float: "left" }}
              variant="outlined"
              onClick={() => handleAgency()}
            >
              Agency Dashboard
            </PrimaryButton>
          )}

          <PrimaryButton
            style={{ float: "left" }}
            variant="outlined"
            onClick={() => dispatch(signOutMember())}
          >
            Logout
          </PrimaryButton>
        </div>
        <div className="wrapper-container">
          {brands.length > 0 ? (
            <Fragment>
              <Typography className="who">Who's using?</Typography>

              {component === "admin" ? (
                <Typography>
                  Select Your Access Type: Admin or Brand Account
                </Typography>
              ) : (
                <Typography className="choose-brand">
                  Please choose your preferred brand and indicate your role for
                  seamless processing of your selection.
                </Typography>
              )}
            </Fragment>
          ) : (
            <Fragment>
              <Typography
                style={{ color: colors.sprintexBlue }}
                className="who"
              >
                Enhance your experience
              </Typography>
              <Typography className="choose-brand">
                Add brands to your account to better target your audience!
              </Typography>
            </Fragment>
          )}
        </div>

        {component === "admin" ? (
          <AdminForm brands={brands} />
        ) : (
          <Form
            setCurrentBrand={setCurrentBrand}
            currentBrand={currentBrand}
            brands={brands}
            businessEntityID={businessEntityID}
            userID={userID}
          />
        )}
      </Box>
    </Box>
  );

  async function addNewBrand() {
    sessionStorage.setItem("role", "AGENCY");
    await dispatch(
      signInMember({
        authToken: authToken,
        userID: userID,
        businessEntityId: businessEntityID,
        brandType: currentBrand.type,
      })
    );
    dispatch(
      setActiveBrand({
        ID: "",
        about: "",
        brandName: "",
        logo: "",
        languages: [],
        locations: [],
        category: [],
        mau: "",
        onlineStore: "",
        website: "",
        socialMedia: {},
        brandType: "",
      })
    );
    navigate(pages.brandDetailCreateEmpty.route + "?newMultiBrand=" + true);
  }

  async function handleAgency() {
    sessionStorage.setItem("role", "AGENCY");
    await dispatch(
      signInMember({
        authToken: authToken,
        userID: userID,
        businessEntityId: businessEntityID,
        brandType: currentBrand.type,
      })
    );

    navigate(
      dashboardLayoutRoutes.agencyDetailsRoute.path + "?agencyID=" + agencyID
    );
  }
}
